export enum Experiments {
  ManageBadgesButtonInMainTab = 'specs.membersArea.ManageBadgesButton',
  RefreshWidgetsOnSettingsChange = 'specs.membersArea.RefreshWidgetsOnSettingsChange',
  MyAccountOOI = 'specs.myAccount.OOI',
  ViewerCustomProfile = 'specs.membersArea.viewerCustomProfile',
  UrlMembersArea = 'specs.membersArea.urlMembersArea',
}
